import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_ADD_VULNERABILITY_SCORE');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const addVulnerabilityScoreRequest = createAction('ADD_VULNERABILITY_SCORE_POST_REQUEST');
export const addVulnerabilityScoreSuccess = createAction('ADD_VULNERABILITY_SCORE_POST_SUCCESS');
export const addVulnerabilityScoreError = createAction('ADD_VULNERABILITY_SCORE_POST_ERROR');

export const addVulnerabilityScore = (request) => async (dispatch) => {
  try {
    dispatch(addVulnerabilityScoreRequest());
    const resp = await instance.post(`/v1/RatingScore/Post`, request);

    dispatch(addVulnerabilityScoreSuccess(resp.data));
  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(addVulnerabilityScoreError(e.response.data.description));
    else
      dispatch(addVulnerabilityScoreError(e.message));
  }
};
